module.exports = __webpack_public_path__ + "static/media/headertongyu3.56cbe88e.png";